import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ProcessingBar2 from "../../../../components/ProcessingBar/ProcessingBar2";

const FirstBarber = () => {
  const navigate = useNavigate();
  const [showProcessing, setShowProcessing] = useState(false);
  const [showProcessingCall, setShowProcessingCall] = useState(false);

  const handleregister = () => {
    setShowProcessing(true);
    setTimeout(() => {
      setShowProcessing(false); // (optional: hide after processing)
      navigate("/register");
    }, 2000);
  };

  const handleBookACall = () => {
    setShowProcessingCall(true);
    setTimeout(() => {
      setShowProcessingCall(false);
      navigate("/contact/book-a-call");
    }, 2000);
  };
  return (
    <div className="bg-black min-h-screen pb-16 pt-16">
      {/* Hero Section */}
      <div className="max-w-6xl mx-auto px-4 pt-20">
        <h1 className="text-4xl md:text-5xl font-semibold text-text mb-6 leading-snug">
          Barber shop management, redefined.
          <br />
          Cut sharper. Run smoother. Grow faster.
        </h1>
        <hr className="border border-border my-3 w-16" />
        <p className="text-sm text-textGray mb-8 max-w-3xl">
          Streamline bookings, deliver a premium client experience, and build
          your barber brand — all in one powerful platform. Lokalai makes
          running your shop effortless.
        </p>
        <button
          onClick={handleregister}
          className="bg-redlight text-text px-6 py-3 rounded-full font-semibold text-sm transition-transform duration-200 hover:scale-105 w-[200px] h-[45px]"
        >
          {showProcessing ? (
            <div className="flex items-center justify-center w-full h-full">
              <ProcessingBar2 />
            </div>
          ) : (
            "Start 30-day free"
          )}
        </button>
      </div>

      {/* Video/Image Section */}
      <div className="max-w-4xl mx-auto px-4 mt-16">
        <div className="rounded-xl overflow-hidden shadow-lg">
          <img
            src="https://images.pexels.com/photos/1813272/pexels-photo-1813272.jpeg" // replace with your actual file path
            alt="Nail salon"
            className="w-full object-cover grayscale"
          />
        </div>
      </div>
    </div>
  );
};

export default FirstBarber;
